/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Box, BoxProps } from '@osmosis/tailwind-ui/components/Box';

import AddToPlaylistButton from '../../app/_components/playlist/AddToPlaylistButton';
import AddToWatchLaterButton from '../../app/_components/playlist/AddToWatchLaterButton';

import { useUserContext } from '../../context/UserContext';
import { Tag } from '@osmosis/shared/types/learn';

type Props = {
  video: { learnNodeID: number; name: string };
  containerProps?: BoxProps;
  toBeRetiredTag: Tag | undefined;
  isEmbed?: boolean;
};

/**
 * Video controls to display over the top of the video player.
 */
const TopVideoControls = (props: Props) => {
  const { containerProps = {}, video, toBeRetiredTag, isEmbed } = props;

  const { user } = useUserContext();

  return (
    user && (
      <Box
        onClick={(e) => e.stopPropagation()}
        data-testid="overlay-topcontrols"
        {...containerProps}
        className={`flex flex-wrap-nowrap justify-end items-center p-2 gap-2 z-20 transition-all duration-100 ease-in-out absolute right-0 top-0 ${containerProps.className}`}
      >
        {!toBeRetiredTag && (
          <>
            {/* Leave the add to playlist button only for embedded videos case */}
            {isEmbed && (
              <AddToPlaylistButton
                items={[video]}
                data-testid="video-overlay-add-to-playlist-button"
                buttonProps={{ className: 'bg-gray-800' }}
              />
            )}
            <AddToWatchLaterButton
              video={video}
              data-testid="learn-overlay-watch-later-button"
            />
          </>
        )}
      </Box>
    )
  );
};

export default TopVideoControls;
